import React, { FC } from 'react';

interface MessageProps {
  msg: string;
  type: 'danger' | 'success';
}

const Message: FC<MessageProps> = ({ msg, type }) => {
  let typeClass = '';

  if(type === 'danger') {
    typeClass = 'text-danger';
  }

  if(type === 'success') {
    typeClass = 'text-success';
  }

  return(
    <article className={`message ${typeClass}`} style={{padding:"0px 0px 15px 0"}}>
      <div className="message-body"><b>{msg}</b></div>
    </article>
  );
}

export default Message;